import { render, staticRenderFns } from "./AppBottomNavigation.vue?vue&type=template&id=3065feb0&scoped=true&"
import script from "./AppBottomNavigation.vue?vue&type=script&lang=js&"
export * from "./AppBottomNavigation.vue?vue&type=script&lang=js&"
import style0 from "./AppBottomNavigation.vue?vue&type=style&index=0&id=3065feb0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3065feb0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomNavigation } from 'vuetify/lib/components/VBottomNavigation';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBottomNavigation,VBtn})
